module.exports = __webpack_public_path__ + "static/media/ncbr.832782d5.png";